// eslint-disable-next-line import/prefer-default-export
export const uniqueId = (length) =>
  Math.random().toString(36).substring(length);
